import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UIModule } from './ui/ui.module';

import { WidgetModule } from './widget/widget.module';
import { GetInitialPipe } from '../core/pipe/initial.pipe';

@NgModule({
  declarations: [GetInitialPipe],
  imports: [
    CommonModule,
    UIModule,
    WidgetModule
  ],
  exports:[GetInitialPipe]
})

export class SharedModule { }
